import React from "react";
import { MdClose } from "react-icons/md";
import Badge from "components/badge/Badge";

/**
 * TagBadge — a person tag as a neutral Badge with the tag's own color as a dot.
 * The tag color is user-chosen data, so it is the only inline color.
 *
 * @param {object} props
 * @param {{id, name: string, color: string}} props.tag
 * @param {(tag) => void} [props.onRemove] Renders a remove button when set.
 * @param {"sm"|"md"} [props.size="md"]
 */
const TagBadge = ({ tag, onRemove, size = "md" }) => (
  <Badge tone="neutral" size={size} swatch={tag.color} className="border border-line">
    {tag.name}
    {onRemove && (
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          onRemove(tag);
        }}
        className="-mr-1 rounded-full text-fg-muted transition-colors hover:text-fg focus-ring"
        aria-label={`Remove ${tag.name} tag`}
      >
        <MdClose aria-hidden="true" className="h-3.5 w-3.5" />
      </button>
    )}
  </Badge>
);

export default TagBadge;
